// extracted by mini-css-extract-plugin
module.exports = {"endMsg":"MsgEnd_endMsg__h9FmC"};